import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// Reusable component for anchor tag with hover effect
const AnchorTag = ({ onClick = () => {}, hoverText = "Click Here", highlightColor = "#007bff", children }) => {
  return (
    <OverlayTrigger
      placement="top"  // You can adjust the position: "top", "right", "bottom", or "left"
      overlay={<Tooltip id="link-tooltip">{hoverText}</Tooltip>}  // Display the hoverText as tooltip
    >
      <a
        onClick={onClick}
        href='#'
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: '8px 12px',
          fontSize: '14px',
          color: 'inherit',
          textDecoration: 'none',
          border: '1px solid transparent',
          borderRadius: '4px',
          transition: 'background-color 0.3s ease, color 0.3s ease',
        }}
        className="link-with-hover"
      >
        {children || <span>{hoverText}</span>}
        <style>
          {`
            .link-with-hover:hover {
              background-color: #f8f9fa; /* Default background color on hover */
              color: ${highlightColor}; /* Dynamic text color on hover */
            }
          `}
        </style>
      </a>
    </OverlayTrigger>
  );
};

export default AnchorTag;